/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import ActionCreator from '../action-creator';

interface CompactExportEnabledProps {
  userid: string;
}

export const ActionCreators = {
  RequestConfig: new ActionCreator<'RequestConfig', any>('RequestConfig'),
  ReceivedConfigSuccess: new ActionCreator<'ReceivedConfigSuccess', any>('ReceivedConfigSuccess'),
  ReceivedConfigError: new ActionCreator<'ReceivedConfigError', any>('ReceivedConfigError'),
  ClearReceivedConfigError: new ActionCreator<'ClearReceivedConfigError', any>('ClearReceivedConfigError'),
  RequestCompactExportEnabled: new ActionCreator<'RequestCompactExportEnabled', CompactExportEnabledProps>(
    'RequestCompactExportEnabled',
  ),
  ReceivedCompactExportEnabledSuccess: new ActionCreator<'ReceivedCompactExportEnabledSuccess', any>(
    'ReceivedCompactExportEnabledSuccess',
  ),
  ReceivedCompactExportEnabledError: new ActionCreator<'ReceivedCompactExportEnabledError', any>(
    'ReceivedCompactExportEnabledError',
  ),
  ClearReceivedCompactExportEnabledError: new ActionCreator<'ClearReceivedCompactExportEnabledError', any>(
    'ClearReceivedCompactExportEnabledError',
  ),
  RequestLoginConfig: new ActionCreator<'RequestLoginConfig', any>('RequestLoginConfig'),
  ReceivedLoginConfigSuccess: new ActionCreator<'ReceivedLoginConfigSuccess', any>('ReceivedLoginConfigSuccess'),
  ReceivedLoginConfigError: new ActionCreator<'ReceivedLoginConfigError', any>('ReceivedLoginConfigError')
};

export type Action = typeof ActionCreators[keyof typeof ActionCreators];

export function getConfig() {
  return (dispatch: any) => {
    dispatch(ActionCreators.RequestConfig.create());
  };
}

export function getLoginConfig() {
  return (dispatch: any) => {
    dispatch(ActionCreators.RequestLoginConfig.create());
  }
}

export function clearReceivedConfigError() {
  return (dispatch: any) => {
    dispatch(ActionCreators.ClearReceivedConfigError.create());
  };
}

export function getCompactExportEnabled(userid: string) {
  return (dispatch: any) => {
    dispatch(ActionCreators.RequestCompactExportEnabled.create({ userid: userid }));
  };
}

export function ClearReceivedCompactExportEnabledError() {
  return (dispatch: any) => {
    dispatch(ActionCreators.ClearReceivedCompactExportEnabledError.create());
  };
}
